(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-accordian"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION_ID = '{{ section.id }}';

    // Create a single, delegated, capture-phase controller for all science accordions on the page.
    var globalKey = '__ScienceAccordionStrict__';
    var global = window[globalKey];

    if (!global) {
      global = window[globalKey] = {
        initialized: true,
        observed: false,
        sectionIds: {},
      };

      function getRootForEventTarget(target) {
        if (!target || !target.closest) return null;
        return target.closest('.science-accordion[data-section-id]');
      }

      function getPanelsForRoot(root) {
        if (!root) return [];
        return Array.prototype.slice.call(root.querySelectorAll('details.science-accordion__panel'));
      }

      function closeOthers(root, activePanel) {
        getPanelsForRoot(root).forEach(function (panel) {
          if (panel !== activePanel) panel.open = false;
        });
      }

      function toggleExclusive(root, panel) {
        if (!root || !panel) return;

        if (panel.open) {
          panel.open = false;
          return;
        }

        closeOthers(root, panel);
        panel.open = true;
      }

      function normalizeRoot(root) {
        var panels = getPanelsForRoot(root);
        if (!panels.length) return;

        var firstOpen = null;
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].open) {
            firstOpen = panels[i];
            break;
          }
        }
        if (firstOpen) closeOthers(root, firstOpen);
      }

      // STRICT click handling (capture phase) so other scripts can't open multiple.
      document.addEventListener(
        'click',
        function (event) {
          var target = event.target;
          var root = getRootForEventTarget(target);
          if (!root) return;

          var summary = target && target.closest ? target.closest('summary') : null;
          if (!summary || !root.contains(summary)) return;

          var panel = summary.closest('details.science-accordion__panel');
          if (!panel || !root.contains(panel)) return;

          event.preventDefault();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          if (event.stopPropagation) event.stopPropagation();
          toggleExclusive(root, panel);
        },
        true
      );

      // STRICT keyboard handling on summary (capture phase)
      document.addEventListener(
        'keydown',
        function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          var target = event.target;
          var root = getRootForEventTarget(target);
          if (!root) return;

          var summary = target && target.closest ? target.closest('summary') : null;
          if (!summary || !root.contains(summary)) return;

          var panel = summary.closest('details.science-accordion__panel');
          if (!panel || !root.contains(panel)) return;

          event.preventDefault();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          if (event.stopPropagation) event.stopPropagation();
          toggleExclusive(root, panel);
        },
        true
      );

      // If any code sets `open` on multiple panels, immediately enforce exclusivity.
      if (window.MutationObserver) {
        var obs = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (m.type !== 'attributes' || m.attributeName !== 'open') continue;

            var target = m.target;
            if (!(target instanceof HTMLElement)) continue;
            if (target.tagName !== 'DETAILS') continue;
            if (!target.classList.contains('science-accordion__panel')) continue;
            if (!target.open) continue;

            var root = getRootForEventTarget(target);
            if (!root) continue;
            closeOthers(root, target);
          }
        });

        obs.observe(document.documentElement, {
          subtree: true,
          attributes: true,
          attributeFilter: ['open'],
        });

        global.observed = true;
      }

      // Expose a small init hook for Theme Editor lifecycle events.
      global.normalizeBySectionId = function (sectionId) {
        var root = document.querySelector('.science-accordion[data-section-id="' + sectionId + '"]');
        if (!root) return;
        normalizeRoot(root);
      };
    }

    // Per-section initialization: normalize this section now (idempotent).
    global.sectionIds[SECTION_ID] = true;
    if (global.normalizeBySectionId) global.normalizeBySectionId(SECTION_ID);

    // In Theme Editor, sections can be re-rendered; re-normalize on lifecycle events.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event && event.target && event.target.getAttribute) {
          var sid = event.target.getAttribute('data-section-id');
          if (sid && global.sectionIds[sid] && global.normalizeBySectionId) global.normalizeBySectionId(sid);
        }
      });

      document.addEventListener('shopify:section:reorder', function (event) {
        if (event && event.target && event.target.getAttribute) {
          var sid = event.target.getAttribute('data-section-id');
          if (sid && global.sectionIds[sid] && global.normalizeBySectionId) global.normalizeBySectionId(sid);
        }
      });

      document.addEventListener('shopify:section:select', function (event) {
        if (event && event.target && event.target.getAttribute) {
          var sid = event.target.getAttribute('data-section-id');
          if (sid && global.sectionIds[sid] && global.normalizeBySectionId) global.normalizeBySectionId(sid);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
